<script>
import axios from 'axios';
import { cmsUrl } from '../variables';
import ContentTextBlock from '../components/ContentTextBlock';
import ContentLogoWallBlock from '../components/ContentLogoWallBlock';
import LoadIndicator from '../components/LoadIndicator';
import ContentContributorsBlock from '../components/ContentContributorsBlock';
import { setTimeout } from 'timers';

export default {
    name: 'InfoPage',
    components: {
        LoadIndicator,
        ContentTextBlock,
        ContentLogoWallBlock,
        ContentContributorsBlock,
    },
    props: {
        slug: String,
    },
    data() {
        return {
            pageData: null,
            error: null,
            isLoading: true,
            linksToCloseOverlay: [],
        }
    },
    mounted() {
        this.init(this.slug);
    },
    methods: {
        init(slug) {
            axios
                .get(cmsUrl + '/pages/?slug=' + slug)
                .then(this.onDataLoaded)
                .catch(err => { this.error = err; this.isLoading = false;})
        },
        onDataLoaded(data) {
            this.pageData = data.data.length > 0 ? data.data[0] : null;
            this.isLoading = false;

            // get links to close overlay
            setTimeout(() => {
                const links = this.$refs.infoPage.getElementsByTagName('a');
                for (let i = 0; i < links.length; i++) {
                    const element = links[i];
                    if (element.classList.contains('close-overlay') && element.target !== '_blank') {
                        this.linksToCloseOverlay.push(element);
                        element.addEventListener('click', () => this.closeOverlay());
                    }
                }
            }, 0);
        },
        closeOverlay() {
            this.$store.dispatch('closeOverlay')
        },
        getComponentName(layout) {
            switch (layout) {
                case 'text_block':
                    return 'ContentTextBlock';

                case 'logo_wall':
                    return 'ContentLogoWallBlock';

                case 'contributors_overview':
                    return 'ContentContributorsBlock';

            }
        },
    },
    beforeDestroy() {
        for (let i = 0; i < this.linksToCloseOverlay.length; i++) {
            const element = this.linksToCloseOverlay[i];
            element.removeEventListener('click', () => this.closeOverlay());
        }
    }
};
</script>

<template>
    <section ref="infoPage" class="info-page" v-on:keyup.esc="onClose()">
        <article class="info-page__main" v-if="!isLoading && pageData">
            <h1 class="info-page__title page-title" v-html="pageData.title.rendered"></h1>
            <p class="info-page__lead page-lead">{{ pageData.page_lead }}</p>
            <component 
                v-for="(block, i) in pageData.content_blocks" 
                v-bind:key="i"
                v-bind:data="block"
                v-bind:mode="'overlay'"
                v-bind:is="getComponentName(block.acf_fc_layout)">
            </component>
        </article>

        <load-indicator v-if="isLoading"></load-indicator>

    </section>
</template>

<style lang="scss">
.info-page {
    color: $color-light;
    max-width: 96rem;
    margin: 12.6rem auto 11.2rem;

    @include breakpoint('md-down') {
        max-width: 78.4rem;
    }

    @include breakpoint('sm-down') {
        display: block;
        box-sizing: border-box;
        width: 100%;
        max-width: 48rem;
        padding: 7.2rem 1.6rem;
        margin: 0 auto;
    }
}

.info-page__main {
    max-width: 56.4rem;
}

.info-page__title {
    max-width: none;
    margin: 5.6rem 0 6.92rem;

    @include breakpoint('sm-down') {
        margin: 1.6rem 2.4rem 4rem 0;
    }
}
</style>
